import { render, staticRenderFns } from "./OrgCommunicationAutoReply.vue?vue&type=template&id=53d8076e&scoped=true&"
import script from "./OrgCommunicationAutoReply.vue?vue&type=script&lang=js&"
export * from "./OrgCommunicationAutoReply.vue?vue&type=script&lang=js&"
import style0 from "./OrgCommunicationAutoReply.vue?vue&type=style&index=0&id=53d8076e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d8076e",
  null
  
)

export default component.exports